export const UPDATE_DEVICE_DIMENSIONS = "UPDATE_DEVICE_DIMENSIONS"
export const UPDATE_DEVICE_DETAILS = "UPDATE_DEVICE_DETAILS"
export const UPDATE_CONNECTION_SPEED = "UPDATE_CONNECTION_SPEED"